import { render, staticRenderFns } from "./create-profile-step-1.vue?vue&type=template&id=545f46ed"
import script from "./create-profile-step-1.vue?vue&type=script&lang=js"
export * from "./create-profile-step-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports